import React, { FC, useState } from "react";
import "./ProductSaveForLaterButton.scss";
import heartLight from "../../../../../Assets/Images/icon/heart-light.png";
import productService from "Services/productService";
import toast from "react-hot-toast";

interface propsType {
  color?: string;
  productUuid?: string;
}

const ProductSaveForLaterButton: FC<propsType> = ({ color, productUuid }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleSaveForLater = async (productUuid?: string) => {
    if (!productUuid) return;
    try {
      setLoading(true);
      await productService.savedProduct(productUuid);

      toast.success("Product saved for later", {
        duration: 1000,
        className: "bg-white text-secondary",
        position: "top-right",
      });
    } catch (error: any) {
      toast.error(error.response.data.message || error.response.data.error, {
        duration: 1000,
        className: "custom-alert bg-white text-dark",
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={() => handleSaveForLater(productUuid)}
      className="global-heroBtn global-heroBtn-outline save-for-later-outline"
    >
      {!color ? (
        <img className="d-none" src={heartLight} />
      ) : (
        <svg
          className="me-2 pe-2"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.62 20.8116C12.28 20.9316 11.72 20.9316 11.38 20.8116C8.48 19.8216 2 15.6916 2 8.69156C2 5.60156 4.49 3.10156 7.56 3.10156C9.38 3.10156 10.99 3.98156 12 5.34156C13.01 3.98156 14.63 3.10156 16.44 3.10156C19.51 3.10156 22 5.60156 22 8.69156C22 15.6916 15.52 19.8216 12.62 20.8116Z"
            stroke="#F5A623"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {loading ? (
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      ) : (
        "Save for later"
      )}
    </button>
  );
};

export default ProductSaveForLaterButton;
